import React from 'react'
// import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
// import Widget from '@jimmyboys/liita-ui/dist/components/Widget'

// import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
// import { useFetchList } from 'store'

// import styles from './ContextualController.module.sass'
// import Collection from '@jimmyboys/liita-ui/dist/components/Collection'
// import BarChart from 'components/charts/BarChart/BarChart'
// import { moment } from 'localization'

// const TaskRow = (props) => {
// 	const { data, ...attributes } = props
// 	return (
// 		<div {...attributes} className={styles['row']}>
// 			<h5>{data?.medic}</h5>
// 			<small className={styles['medium']}>{data?.total || 0}</small>
// 			<small className={styles['medium']}>
// 				{data?.totalUnfinished || 0}
// 			</small>
// 		</div>
// 	)
// }

// const medicalTasksByType = (data, typesToFilter = []) => {
// 	let tasksByTypes = []
// 	if (typesToFilter.length) {
// 		tasksByTypes = (data || []).filter(({ type }) =>
// 			typesToFilter.includes(type)
// 		)
// 	} else {
// 		tasksByTypes = data || []
// 	}

// 	return tasksByTypes.reduce((acc, { countByTaskType }) => {
// 		;(countByTaskType || []).forEach(
// 			({ user, completedCount, pendingCount }) => {
// 				if (!acc[user.id]) {
// 					acc[user.id] = {
// 						medic: user.name || user.id,
// 						total: 0,
// 						totalUnfinished: 0,
// 					}
// 				}

// 				acc[user.id].total += completedCount
// 				acc[user.id].totalUnfinished += pendingCount
// 			}
// 		)

// 		return acc
// 	}, {})
// }

// const tasksPerDay = (data) => {
// 	return (data || []).map(({ date, count }) => {
// 		return {
// 			date: moment(new Date(date)).format('DD'),
// 			total: count,
// 		}
// 	})
// }

const ContextualHomepageController = () => {
	// const { i18n } = useGlobal()

	// const {
	// 	contents: [stats],
	// } = useFetchList(['/tasks/admin_stats'], [])

	// const { taskCreationHistoryStats, userCountPerTaskType } = stats || {}

	// const clinicalPendingTypes = [
	// 	'AppointmentClinicalApproval',
	// 	'MedicalActsClinicalApproval',
	// 	'RelapseClinicalApproval',
	// 	'SurgeryClinicalApproval',
	// 	'TransferClinicalApproval',
	// ]
	// const clinicalEvaluationTypes = ['MedicalEvaluation']
	// const ippForecastTypes = ['FinalSituationPrevision']

	// const clinicalPendingsData = medicalTasksByType(
	// 	userCountPerTaskType,
	// 	clinicalPendingTypes
	// )
	// const clinicalEvaluationData = medicalTasksByType(
	// 	userCountPerTaskType,
	// 	clinicalEvaluationTypes
	// )
	// const ippForecastData = medicalTasksByType(
	// 	userCountPerTaskType,
	// 	ippForecastTypes
	// )

	// const clinicalPendingsTasks = (
	// 	taskCreationHistoryStats || []
	// ).find(({ type }) => clinicalPendingTypes.includes(type))
	// const clinicalPendingsTasksPerDay = tasksPerDay(
	// 	clinicalPendingsTasks?.dailyCount
	// )

	// const triageTasks = (taskCreationHistoryStats || []).find(
	// 	({ type }) => type === 'Triage'
	// )
	// const triageTasksPerDay = tasksPerDay(triageTasks?.dailyCount)

	// const clinicalEvaluationTasks = (taskCreationHistoryStats || []).find(
	// 	({ type }) => type === 'MedicalEvaluation'
	// )
	// const clinicalEvaluationTasksPerDay = tasksPerDay(
	// 	clinicalEvaluationTasks?.dailyCount
	// )

	// const ippForecastTasks = (taskCreationHistoryStats || []).find(
	// 	({ type }) => type === 'FinalSituationPrevision'
	// )
	// const ippForecastTasksPerDay = tasksPerDay(ippForecastTasks?.dailyCount)

	return (
		<>
			{/* <Widget
				className={styles['welcome-widget']}
				paddings={['small', '', '']}
			>
				<h2 className={styles['welcome-title']}>{i18n`Stats`}</h2>
				<small>{i18n`Allocated and Resolved Tasks`}</small>
			</Widget>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`Clinical Pending by Medic`}
				expanded={
					Object.values(clinicalPendingsData || {})?.length
						? true
						: false
				}
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<Widget className={styles['aside-widget-content']}>
					<div
						className={`${styles['list-header']} ${styles['--subtitle']}`}
					>
						<h5>{i18n`Name`}</h5>
						<small>{i18n`No. Finished`}</small>
						<small>{i18n`No. N/finished`}</small>
					</div>
					<Collection
						itemsHeight={28}
						card={TaskRow}
						items={Object.values(clinicalPendingsData || {})}
					/>
				</Widget>
			</ExpandableWidget>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`Clinical Evaluation by Medic`}
				expanded={
					Object.values(clinicalEvaluationData || {})?.length
						? true
						: false
				}
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<Widget className={styles['aside-widget-content']}>
					<div
						className={`${styles['list-header']} ${styles['--subtitle']}`}
					>
						<h5>{i18n`Name`}</h5>
						<small>{i18n`No. Finished`}</small>
						<small>{i18n`No. N/finished`}</small>
					</div>
					<Collection
						itemsHeight={28}
						card={TaskRow}
						items={Object.values(clinicalEvaluationData || {})}
					/>
				</Widget>
			</ExpandableWidget>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`IPP Forecast by Medic`}
				expanded={
					Object.values(ippForecastData || {})?.length ? true : false
				}
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<Widget className={styles['aside-widget-content']}>
					<div
						className={`${styles['list-header']} ${styles['--subtitle']}`}
					>
						<h5>{i18n`Name`}</h5>
						<small>{i18n`No. Finished`}</small>
						<small>{i18n`No. N/finished`}</small>
					</div>
					<Collection
						itemsHeight={28}
						card={TaskRow}
						items={Object.values(ippForecastData || {})}
					/>
				</Widget>
			</ExpandableWidget>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`Created Clinical Pending per day`}
				expanded={clinicalPendingsTasksPerDay?.length ? true : false}
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<BarChart
					data={clinicalPendingsTasksPerDay}
					category='date'
					value='total'
				/>
			</ExpandableWidget>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`Created Triage per day`}
				expanded={triageTasksPerDay?.length ? true : false}
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<BarChart
					data={triageTasksPerDay}
					category='date'
					value='total'
				/>
			</ExpandableWidget>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`Created Clinical Evaluations per day`}
				expanded={clinicalEvaluationTasksPerDay?.length ? true : false}
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<BarChart
					data={clinicalEvaluationTasksPerDay}
					category='date'
					value='total'
				/>
			</ExpandableWidget>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`Created IPP Forecast per day`}
				expanded={ippForecastTasksPerDay?.length ? true : false}
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<BarChart
					data={ippForecastTasksPerDay}
					category='date'
					value='total'
				/>
			</ExpandableWidget> */}
		</>
	)
}

export default ContextualHomepageController
